import { ErrorBase } from './error-base';

type NotFoundErrorData = {
  actionProps: {
    to: string;
    label: string;
  };
};

export class NotFoundError extends ErrorBase<NotFoundErrorData> {
  constructor(data: NotFoundErrorData) {
    super(404, 'Not Found', data);
  }
}
